@if(config()?.enabled && config()?.templateId && config()?.businessunitId) {
<trustpilot-widget [templateId]="config()?.templateId || ''"
                   class="pe-none"
                   [businessunitId]="config()?.businessunitId || ''"
                   [locale]="'en-US'"
                   [styleHeight]="'24px'"
                   [styleWidth]="'100%'"
                   [theme]="config()?.theme || 'light'"
                   [starColor]="config()?.starColor || '#fdb714'"
                   [sku]="sku() || ''"
                   [name]="product().data?.name || ''"
                   [styleAlignment]="'left'"
                   [noReviews]="'collapse'"
                   [reviewLanguages]="'en'"
                   [availability]="product().trustpilotAvailability || ''"
                   [price]="product().price" />
}